export default {
	purchase: 'Satın alma',
	sell: 'Satış'
}